let IS_PROD = true;
const server = IS_PROD ?
    //"https://bbscollegebackend.onrender.com"
    "https://apnacollegebackend.onrender.com":

    "http://localhost:8000"


export default server;